import React, { createContext, FC, useContext } from 'react';
import { useAnnotationsStore } from 'modules/Annotations/contexts/AnnotationsStoreContext';
import { useCanvasStore } from 'modules/Canvas/contexts/CanvasStoreContext';
import { RootStore, VideoTrackTimelineStore } from '../stores';

export const StoreContext = createContext<RootStore>(RootStore.getInstance());

export const StoreProvider: FC = ({ children }) => {
  const annotationsStore = useAnnotationsStore();
  const canvasStore = useCanvasStore();
  const rootStore = RootStore.getInstance(annotationsStore, canvasStore);

  return <StoreContext.Provider value={rootStore}>{children}</StoreContext.Provider>;
};

export const useRootStore = (): RootStore => {
  return useContext(StoreContext);
};

export const useVideoTrackTimelineStore = (): VideoTrackTimelineStore => {
  const store = useRootStore();

  return store.getVideoTrackTimelineStore();
};
